module.exports = __webpack_public_path__ + "static/media/mappointer.cd30a32d.svg";